import styled from 'styled-components'

export const Logo = styled.div`
  width: 50px;
  height: 50px;
  background: url(${({ src }) => src}) no-repeat center center;
  background-size: contain;
  border-radius: 50%;
  margin-right: 20px;
`
